
export const EMAIL_STATUS_OK = 20000;
export const EMAIL_STATUS_BAD_REQUEST = 40000;
export const EMAIL_STATUS_NOT_FOUND = 40004;
export const EMAIL_STATUS_ERROR = 50000;



// WEBPACK FOOTER //
// ./src/redux/email/status.js